/**
 * Русская плюрализация. «2 будущих записей» и «21 дней» — баги, которые уже ловили,
 * поэтому число в интерфейсе выводится только через это.
 */
export function plural(n: number, one: string, few: string, many: string): string {
  const abs = Math.abs(n) % 100;
  const last = abs % 10;
  if (abs > 10 && abs < 20) return many;
  if (last > 1 && last < 5) return few;
  if (last === 1) return one;
  return many;
}

/** «3 записи» — число вместе со словом. */
export const pluralWithCount = (n: number, one: string, few: string, many: string): string =>
  `${n} ${plural(n, one, few, many)}`;
